<template>
  <div class="head_rightArea flex_center">
    <div class="loginMenu_wrapper">
      <div class="loginMenu_inner">
        <div class="loginName_wrapper">
          <span @click.stop="collapseUserMenu">
            {{ (user.name + "(" + user.organization + ")") | truncate }}
            <fa-icon icon="angle-down" />
          </span>
          <transition name="fade">
            <ul class="loginMenu_list inner" v-show="collapsed">
              <li><a href="#" @click="logout">ログアウト</a></li>
              <!--ToDo https://valeur.backlog.jp/view/YOSHIDA_VIRTUAL-590 イベント後、戻す-->
              <li v-if="!(Number(this.event.id) === Number(this.$config.app.noneLogoEventId))">
                <router-link :to="{name: 'Setting', params: {slug: $store.getters['event/slug']}}">登録情報</router-link>
              </li>
              <li v-if="$store.getters['auth/isAdmin']">
                <a href="#" @click="invertModalStatus">アナウンス</a>
              </li>
              <li v-if="$store.getters['auth/isAdmin']">
                <a href="#" @click="invertQuestionnaireModalStatus">アンケート</a>
              </li>
              <!--ToDo https://valeur.backlog.jp/view/YOSHIDA_VIRTUAL-590 イベント後、戻す-->
              <li v-if="!(Number(this.event.id) === Number(this.$config.app.noneLogoEventId))">
                <a href="#" @click="invertCautionModalStatus">注意事項</a>
              </li>
              <li v-if="!(Number(this.event.id) === Number(this.$config.app.noneLogoEventId))">
                <a href="#" @click="invertTroubleModalStatus">トラブルの際は…</a>
              </li>
            </ul>
          </transition>
        </div>
      </div>
    </div>
    <transition name="fade" v-if="showModal">
      <Modal @close="invertModalStatus">
        <div slot="content">
          <div class="content-header inner">
            <h2>
              <span>アナウンス</span>
            </h2>
            <button @click="invertModalStatus" class="close-btn">
              <fa-icon icon="times" />
            </button>
          </div>
          <NoticeManagement />
        </div>
      </Modal>
    </transition>
    <transition name="fade" v-if="showQuestionnaireModal">
      <Modal @close="invertQuestionnaireModalStatus">
        <div slot="content">
          <div class="content-header inner">
            <h2>
              <span>アンケート</span>
            </h2>
            <button @click="invertQuestionnaireModalStatus" class="close-btn">
              <fa-icon icon="times" />
            </button>
          </div>
          <QuestionnaireManagement />
        </div>
      </Modal>
    </transition>
    <Caution @invert-modal-status="invertCautionModalStatus" :show-modal="showCautionModal" />
    <Trouble @invert-modal-status="invertTroubleModalStatus" :show-modal="showTroubleModal" />
  </div>
</template>

<script>
import Modal from "../elements/Modal"
import NoticeManagement from "./NoticeManagement"
import Caution from "./Caution"
import Trouble from "./Trouble"
import QuestionnaireManagement from "./QuestionnaireManagement"

export default {
  name: "LoginUser",
  components: {Trouble, Caution, Modal, NoticeManagement, QuestionnaireManagement},
  computed: {
    user() {
      return this.$store.getters["auth/user"]
    },
    collapsed() {
      return this.$store.getters["userMenu/collapsed"]
    },
    event() {
      return this.$store.getters["event/event"]
    }
  },
  data: function() {
    return {
      showModal: false,
      showCautionModal: false,
      showTroubleModal: false,
      showQuestionnaireModal: false
    }
  },
  /////////////////////////////////////
  // メソッド
  /////////////////////////////////////
  methods: {
    collapseUserMenu: function() {
      this.$store.dispatch("userMenu/collapse", !this.collapsed)
    },
    logout: function() {
      this.$store.commit("loading/setLoading", true)
      this.$store.dispatch("auth/logout")
    },
    invertModalStatus() {
      this.showModal = !this.showModal
    },
    invertCautionModalStatus() {
      this.showCautionModal = !this.showCautionModal
    },
    invertTroubleModalStatus() {
      this.showTroubleModal = !this.showTroubleModal
    },
    invertQuestionnaireModalStatus() {
      this.showQuestionnaireModal = !this.showQuestionnaireModal
    }
  },
  filters: {
    truncate: function(value) {
      const length = 27
      const omission = "..."
      if (value.length <= length) return value

      return value.substring(0, length) + omission
    }
  }
}
</script>
